// Configuration for preview component types based on record type
// This defines which record types have multiple preview options

export const PREVIEW_TYPE_CONFIG = {
  // Record types with multiple preview options
  "Splash Page": {
    defaultPreview: "ProjectCard",
    options: [
      { label: "Project Card", value: "ProjectCard" },
      { label: "Project Card - Invite", value: "ProjectCardInvite" },
      { label: "Banner", value: "Banner" },
    ],
  },
  "Microsoft Project Page": {
    defaultPreview: "ClientTasks",
    options: [
      { label: "Client Tasks", value: "ClientTasks" },
      { label: "Client Tasks - Full View", value: "ClientTasksFullView" },
    ],
  },
  ProjectObjective: {
    defaultPreview: "ProjectQualificationPage",
    options: [
      {
        label: "Project Qualification Page",
        value: "ProjectQualificationPage",
      },
      {
        label: "Project Qualifying Page",
        value: "ProjectQualifyingPage",
      },
      {
        label: "Project Active Page",
        value: "CommonProjectPage",
      },
    ],
  },
};

/**
 * Get preview options for a given record type
 * @param {string} recordTypeName - The record type name
 * @returns {object|null} - Configuration object with defaultPreview and options, or null if no config
 */
export function getPreviewOptionsForRecordType(recordTypeName) {
  if (!recordTypeName) return null;
  return PREVIEW_TYPE_CONFIG[recordTypeName] || null;
}

/**
 * Check if a record type has multiple preview options
 * @param {string} recordTypeName - The record type name
 * @returns {boolean}
 */
export function hasMultiplePreviewOptions(recordTypeName) {
  const config = getPreviewOptionsForRecordType(recordTypeName);
  return config && config.options && config.options.length > 1;
}

/**
 * Get default preview type for a record type
 * @param {string} recordTypeName - The record type name
 * @returns {string|null} - Default preview type or null
 */
export function getDefaultPreviewType(recordTypeName) {
  const config = getPreviewOptionsForRecordType(recordTypeName);
  return config?.defaultPreview || null;
}
